import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { Reveal } from './Reveal';
import { testimonials } from '../data/landing';
export function TestimonialsSection() {
  return <section className="bg-white py-16 sm:py-24" data-id="element-206" data-mp="1mz90r7l5lwc9">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-207" data-mp="1r1dv68jfewzy">
        <SectionHeading title="Lo que dicen los técnicos que ya lo usan" data-id="element-208" data-mp="1r02s6axt1t9w" />
        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-209" data-mp="1d0tb791ryv4v">
          {testimonials.map((t, i) => <Reveal as="li" key={t.name} delay={i * 0.05} className="h-full" data-id="element-210" data-mp="1i1qtdlmsbp6d" data-mpi={i}>
              <div className="flex h-full flex-col rounded-2xl border border-slate-200 bg-slate-50 p-6" data-id="element-211" data-mp="141y5rz6k1p2m">
                <div className="flex items-center gap-3" data-id="element-212" data-mp="183t54y4xdsdr">
                  <span className="grid h-12 w-12 place-items-center rounded-full bg-ink text-sm font-bold text-white" aria-hidden="true" data-id="element-213" data-mp="2yf7is0yb7spm">
                    {t.initials}
                  </span>
                  <div data-id="element-214" data-mp="32eg8muq8b6fw">
                    <p className="font-bold text-ink" data-id="element-215" data-mp="2v12l0xn2qd9l">{t.name}</p>
                    <p className="text-sm text-slate-500" data-id="element-216" data-mp="2uz80hkfpsn61">
                      {t.role} · {t.city}
                    </p>
                  </div>
                </div>
                <blockquote className="mt-4 text-base leading-relaxed text-slate-700" data-id="element-217" data-mp="34quji2yanqjc">“{t.quote}”</blockquote>
                <div className="mt-auto flex gap-0.5 pt-5" aria-label="5 de 5 estrellas" data-id="element-218" data-mp="2zt2sdb5h48g7">
                  {Array.from({
                length: 5
              }).map((_, s) => <StarIcon key={s} className="h-5 w-5 fill-amber-400 text-amber-400" aria-hidden="true" data-id="element-219" data-mp="27458x4pj05lv" data-mpi={s} />)}
                </div>
              </div>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}